/*
  Jiro's Wineshop — 商品写真の「ふわっと浮かび上がる」演出トリガー。

  CSS の固定時間 animation だけに頼ると、ネットワーク越しの画像読み込みが
  演出時間より長くかかった場合、演出が終わったあとにポンと画像が現れる
  だけになり「フェードインしていない」ように見える。
  ここでは対象画像の実際の読み込み完了(load / 既にキャッシュ済みなら
  complete)を検知して .is-lux-revealed を付与し、CSS 側の transition
  （assets/luxury.css）を発火させる。読み込み失敗時やタイムアウト時にも
  必ず表示される fail-safe を備える。

  対象: .product__media-item（商品詳細ページのギャラリー）
        .card__media（商品カード・コレクション一覧・トップの商品グリッド）
  コレクションの絞り込み等で DOM が動的に差し替わっても追従できるよう
  MutationObserver で新規要素を継続的に監視する。
*/
(function () {
  var SELECTOR = '.product__media-item, .card__media';
  var REVEAL_CLASS = 'is-lux-revealed';
  var FAILSAFE_MS = 2500;
  var seen = new WeakSet();

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function setup(el) {
    if (seen.has(el)) return;
    seen.add(el);

    var img = el.querySelector('img');
    if (!img) {
      reveal(el);
      return;
    }
    if (img.complete && img.naturalWidth > 0) {
      reveal(el);
      return;
    }
    img.addEventListener('load', function () { reveal(el); }, { once: true });
    img.addEventListener('error', function () { reveal(el); }, { once: true });
    window.setTimeout(function () { reveal(el); }, FAILSAFE_MS);
  }

  function scan(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
    if (scope.matches && scope.matches(SELECTOR)) setup(scope);
  }

  function init() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify のセクション再読み込み（テーマエディタでの編集・quick-add 等）
  document.addEventListener('shopify:section:load', function (ev) {
    scan(ev.target || document);
  });

  // 絞り込み(facets)・無限スクロール等、独自JSでDOMが差し替わるケースの保険。
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) scan(node);
        }
      }
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();
